module.exports = "/static/assets/8faab8c26c6c65ac6317af5c8587f6c4.png";